import React from 'react';
import { cn } from '@/lib/utils';

interface UniverseBadgeProps {
  universe: 'Online' | 'Live';
  className?: string;
}

/**
 * Badge réutilisable pour afficher "Online" ou "Live" avec la charte graphique standardisée
 */
export const UniverseBadge: React.FC<UniverseBadgeProps> = ({ universe, className }) => {
  return (
    <span
      className={cn(
        'px-3 py-1 font-bold rounded-full w-fit uppercase',
        'text-[0.80rem]',
        universe === 'Online'
          ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400'
          : 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-400',
        className
      )}
    >
      {universe}
    </span>
  );
};
